import 'bootstrap/dist/css/bootstrap.min.css'
import '../styles/Home.css';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Logo from '../assets/swift_response.png'
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';


const Home = ()=>{

    const navigate = useNavigate();

    const [telephone,setTelePhone] = useState(localStorage.getItem('telephone'));
    const [name,setName] = useState(localStorage.getItem('firstName'));
    const [lastName,setLastName] = useState(localStorage.getItem('lastName'));
    const [userOtp,setUserOtp] = useState(null);
    const [otpModal,setOtpModal] = useState(false);
    const [loading,setLoading] = useState(false);
    const [error,setError] = useState(null);


    const apiBaseUrl = process.env.NODE_ENV === 'development'
        ? "https://swiftresponse.online"
        : process.env.REACT_APP_API_URL;
    axios.defaults.baseURL = apiBaseUrl;

    const checkClientData = ()=>{
        if(localStorage.getItem('firstName') != null & localStorage.getItem('lastName') != null & localStorage.getItem('telephone') != null);
        {
            var tel = localStorage.getItem('telephone');
            var lastNm = localStorage.getItem('lastName');
            var firstNm = localStorage.getItem('firstName');
            console.log(`User ${firstNm} last name is ${lastNm} and Phone number is ${tel}`);
            setTelePhone(tel);
            setLastName(lastNm);
            setName(firstNm);
            generateAndSendOTP();
        }
    }

    const normalizeKenyanPhone = (rawPhone) => {
        if (!rawPhone) return '';

        let digitsOnly = rawPhone.replace(/\D/g, '');

        if (digitsOnly.startsWith('254')) {
            digitsOnly = digitsOnly.slice(-12);
        } else if (digitsOnly.startsWith('0')) {
            digitsOnly = `254${digitsOnly.slice(1)}`;
        } else if (digitsOnly.length === 9) {
            digitsOnly = `254${digitsOnly}`;
        }

        return digitsOnly;
    };

    

    const getApiErrorMessage = (err, fallbackMessage) => {
        const topLevel = err.response?.data?.error;
        const details = err.response?.data?.details;

        if (Array.isArray(details) && details.length > 0) {
            return details.map((item) => item.message).join(', ');
        }

        return topLevel || fallbackMessage;
    };

    const generateAndSendOTP = async() => {
        if (!telephone || telephone.trim().length < 9) {
            setError("Please enter a valid phone number");
            return;
        }
        
        const trimmedName = (name || '').trim();
        const trimmedLastName = (lastName || '').trim();

        if (!trimmedName || !trimmedLastName) {
            setError("Please enter your first and last name");
            return;
        }

        if (trimmedName.length < 2 || trimmedLastName.length < 2) {
            setError("First and last name must be at least 2 characters");
            return;
        }
        
        setLoading(true);
        setError(null);
        
        try {
            // Normalize phone number format
            const normalizedPhone = normalizeKenyanPhone(telephone.trim());

            if (!/^254[17]\d{8}$/.test(normalizedPhone)) {
                setError('Phone number format is invalid. Use 0712345678 or 712345678.');
                setLoading(false);
                return;
            }
            
            const url = "/generateotp";
            const headers = {
                'Content-Type': 'application/json',
            }
            const body = {
                'phoneNumber': normalizedPhone,
                'name': trimmedName,
                'surname': trimmedLastName
            };

            const response = await axios.post(url, body, {headers: headers});
            
            if (response.data.success) {
                setOtpModal(true);
            } else {
                setError(response.data.error || "Failed to send OTP");
            }
        } catch (err) {
            console.error('Error sending OTP:', err);
            setError(getApiErrorMessage(err, "Failed to send OTP. Please try again."));
        } finally {
            setLoading(false);
        }
    }

    const verifyOTP = async() => {
        if (!userOtp || userOtp.length !== 6) {
            setError("Please enter a valid 6-digit OTP");
            return;
        }
        
        setLoading(true);
        setError(null);
        
        try {
            // Normalize phone number format (must match the one used in generateOTP)
            const normalizedPhone = normalizeKenyanPhone(telephone.trim());

            if (!/^254[17]\d{8}$/.test(normalizedPhone)) {
                setError('Phone number format is invalid. Use 0712345678 or 712345678.');
                setLoading(false);
                return;
            }
            
            const url = "/verifyotp";
            const headers = {
                'Content-Type': 'application/json',
            }
            const body = {
                'phoneNumber': normalizedPhone,
                'otp': userOtp,
                'name': (name || '').trim(),
                'surname': (lastName || '').trim()
            };

            const response = await axios.post(url, body, {headers: headers});
            
            if (response.data.success) {
                if (process.env.NODE_ENV === 'development' && response.data.debugUser) {
                    console.log('[CLIENT DEBUG] verifyotp', response.data.debugUser);
                }

                // Store JWT token
                localStorage.setItem('authToken', response.data.token);
                localStorage.setItem('customerData',response.data.customer);
                
                // Navigate to callout page with customer data
                navigate("/callout", {state: {customer: response.data.customer}});
            } else {
                setError(response.data.error || "Invalid OTP");
            }
        } catch (err) {
            console.error('Error verifying OTP:', err);
            setError(getApiErrorMessage(err, "Failed to verify OTP. Please try again."));
        } finally {
            setLoading(false);
        }
    }

    useEffect(()=>{
        checkClientData();
    },[])
    return(
        <div className="container-fluid">
            <div className="formContainer">
                <div className='col-md-6 m-4 p-5 mx-auto d-block shadow' id='formLogin'>
                    <img className='logo mx-auto d-block rounded-circle shadow my-3' width="100px" height="100px" src={Logo} alt='logo'/>
                  
                    <div> 
                        {/* Phone Number Input */}
                        <div className='input-group mb-3'>
                            <div className='input-group-prepend'>
                                <span className='input-group-text'>+254</span>
                            </div>
                            <input 
                                type='tel' 
                                className='form-control' 
                                placeholder='Phone Number' 
                                onChange={(e)=>{
                                    setTelePhone(e.target.value);
                                    localStorage.setItem('telephone',e.target.value)
                                    
                                }}
                            />
                        </div>

                        {/* First Name Input */}
                        <div className='form-group mb-3'>
                            <input 
                                type='text' 
                                className='form-control' 
                                autoCapitalize='words' 
                                placeholder='First Name' 
                                onChange={(e)=>{
                                    setName(e.target.value);
                                    localStorage.setItem('firstName',e.target.value);
                                }}
                            />
                        </div>

                        {/* Last Name Input */}
                        <div className='form-group mb-3'>
                            <input 
                                type='text' 
                                className='form-control' 
                                autoCapitalize='words' 
                                placeholder='Last Name' 
                                onChange={(e)=>{
                                    setLastName(e.target.value);
                                    localStorage.setItem('lastName',e.target.value);
                                }}
                            />
                        </div>

                        {/* Error Message */}
                        {error && (
                            <div className="alert alert-danger mb-3" role="alert">
                                {error}
                            </div>
                        )}

                        {/* Register Button */}
                        <div className='form-group'>
                            <button 
                                className='btn btn-outline-danger mx-auto d-block btn-md' 
                                type='button' 
                                onClick={generateAndSendOTP}
                                disabled={loading}
                            >
                                {loading ? 'Sending...' : 'Register'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* OTP Modal */}
            <Modal show={otpModal} onHide={()=>{
                setOtpModal(false);
            }}>
                <Modal.Header closeButton>
                    <Modal.Title className='text-center'>Verify Phone Number</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='form-group'>
                        <label>Enter 6-digit OTP sent to your phone</label>
                        <input 
                            type='text' 
                            className='form-control' 
                            maxLength="6"
                            placeholder="000000"
                            onChange={(e) => {
                                setUserOtp(e.target.value);
                                setError(null);
                            }}
                        />
                    </div>
                    {error && (
                        <div className="alert alert-danger mt-3" role="alert">
                            {error}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className='text-center'>
                    <div className='form-group mx-auto d-block'>
                        <button 
                            className='btn btn-outline-danger btn-md' 
                            onClick={verifyOTP}
                            disabled={loading}
                        >
                            {loading ? 'Verifying...' : 'Verify OTP'}
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

        </div>
    );
}

export default Home;